<script>
  import { fade } from "svelte/transition";

  import { pagingStore } from "../stores/paging.js";
  import Quote from "../components/quote.svelte";
  pagingStore.showPrev(true);
  pagingStore.showNext(true);

  import { laraStore } from "../stores/lara.js";
  laraStore.followMouse(true);

  import { stylesBackground, stylesColor } from "../stores/styles.js";
  stylesBackground.set("black");
  stylesColor.set("white");
</script>

<style>
  @keyframes move-twink-back {
    from {
      mask-position: top left;
    }
    to {
      mask-position: bottom right;
    }
  }
  .stars,
  .twinkling,
  .clouds {
    /* see https://www.script-tutorials.com/night-sky-with-twinkling-stars/ */
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    display: block;
  }
  .stars {
    background: transparent url(../assets/stars.png) repeat top center;
    mask-image: url(../assets/twinkling.png);
    mask-size: 10%;
    mask-position: top left;
    animation: move-twink-back 60s linear infinite;
    z-index: -2;
  }
  .twinkling {
    background: transparent url(../assets/twinkling.png) repeat top center;
    z-index: -1;
    -moz-animation: move-twink-back 600s linear infinite;
    -ms-animation: move-twink-back 600s linear infinite;
    -o-animation: move-twink-back 600s linear infinite;
    -webkit-animation: move-twink-back 600s linear infinite;
    animation: move-twink-back 600s linear infinite;
  }
  .clouds {
    /* background-image: linear-gradient(0deg, rgba(255,204,173,1) 0%, rgba(255,143,96,1) 8%, rgba(144,92,147,1) 25%, rgba(50,79,125,1) 44%, rgba(46,45,92,1) 65%, rgba(26,26,38,1) 100%); */
    background-image: radial-gradient(
      at center bottom,
      rgb(255, 143, 96) 0%,
      rgb(144, 92, 147) 15%,
      rgb(50, 79, 125) 30%,
      rgb(36, 35, 72) 44%,
      rgb(3, 3, 3) 70%
    );
    background-position: center;
    background-size: 1000% 100%;
    z-index: -3;
    /* background: transparent url(../assets/clouds.png) repeat top center;
    z-index: 3;
    -moz-animation: move-clouds-back 200s linear infinite;
    -ms-animation: move-clouds-back 200s linear infinite;
    -o-animation: move-clouds-back 200s linear infinite;
    -webkit-animation: move-clouds-back 200s linear infinite;
    animation: move-clouds-back 200s linear infinite; */
  }
</style>

<div class="page">
  <div in:fade={{ delay: 1000, duration: 3000 }} out:fade={{ duration: 1000 }}>
    <div class="stars" />
    <div class="clouds" />
    <!-- <div class="twinkling" /> -->
  </div>
  <Quote title="Tag 2">
    Die Freiheit des Individuums ist ein fundamentales Prinzip der Föderation
    Validarien, alle dürfen am Ort ihrer Wünsche schaffen.
  </Quote>
</div>
